module.exports = __webpack_public_path__ + "static/media/cancel.85963ff6.svg";